"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = default_1;
const json2csv_1 = require("json2csv");
const get_screenshot_url_1 = require("../utils/get-screenshot-url");
const igt_name_map_1 = require("../utils/igt-name-map");
const issue_mapper_1 = require("../utils/issue-mapper");
function default_1(issues, { baseScreenshotURL } = {}, options = { delimiter: ',' }) {
    const fields = [
        {
            label: 'Rule ID',
            value: 'rule'
        },
        {
            label: 'Description',
            value: 'description'
        },
        {
            label: 'Help',
            value: 'helpText'
        },
        {
            label: 'Help URL',
            value: 'helpUrl'
        },
        {
            label: 'Impact',
            value: (row) => (row.isNeedsReview ? '' : row.impact)
        },
        {
            label: 'Manual',
            value: (row) => (row.isManual ? 'Yes' : 'No')
        },
        {
            label: 'Needs Review',
            value: (row) => (row.isNeedsReview ? 'Yes' : 'No')
        },
        {
            label: 'IGT',
            value: (row) => (0, igt_name_map_1.getIgtName)(row.igtTool)
        },
        {
            label: 'Selector',
            value: 'selector'
        },
        {
            label: 'Summary',
            value: 'summary'
        },
        {
            label: 'Source Code',
            value: 'source'
        },
        {
            label: 'Tags',
            value: (row) => (0, issue_mapper_1.getIssueTags)(row).join(',')
        },
        {
            label: 'Found By',
            value: 'foundBy'
        },
        {
            label: 'Test Title',
            value: 'testName'
        },
        {
            label: 'Test URL',
            value: 'testUrl'
        },
        {
            label: 'Share URL',
            value: 'shareURL'
        },
        {
            label: 'Created At',
            value: 'createdAt'
        },
        {
            label: 'Screenshot URL',
            value: (row) => (0, get_screenshot_url_1.getScreenshotUrl)(baseScreenshotURL, row.screenshotId, row.boundingBox) || ''
        }
    ];
    return (0, json2csv_1.parseAsync)(issues, {
        delimiter: options.delimiter,
        excelStrings: false,
        fields: fields
    });
}
//# sourceMappingURL=csv-axe-devtools.js.map